<a
    class="w-full flex flex-col items-center justify-center bp908:hover:bg-blurple rounded-lg cursor"
    routerLink="/people"
    routerLinkActive="bp908:!bg-blurple-dark"
    (mouseenter)="isHovered = true"
    (mouseleave)="isHovered = false"
    #link="routerLinkActive">
    <fa-icon
        class="text-18 bp908:text-white text-color"
        [icon]="faUserGroup"
        [ngClass]="{ hidden: isHovered || link.isActive }" />
    <fa-icon
        class="text-18 bp908:text-white text-blurple"
        [icon]="faUserGroupSolid"
        [ngClass]="{ hidden: !isHovered && !link.isActive }" />
</a>
